function isWorldCupPage () {
  return window.location.pathname.indexOf('/worldcup2026') === 0
}

function getQueryValue (key) {
  const searches = [window.location.search || '']
  const hash = window.location.hash || ''
  const hashQueryIndex = hash.indexOf('?')
  if (hashQueryIndex >= 0) {
    searches.push(hash.slice(hashQueryIndex))
  }

  for (let i = 0; i < searches.length; i++) {
    const params = new URLSearchParams(searches[i])
    const value = params.get(key)
    if (value !== null) return value
  }
  return null
}

function hasDebugStorage () {
  try {
    return window.localStorage && window.localStorage.getItem('WC2026_DEBUG') === '1'
  } catch (e) {
    return false
  }
}

export function shouldEnableWorldCupDebug () {
  if (!isWorldCupPage()) return false

  const debugValue = getQueryValue('wcdebug') || getQueryValue('wc2026_debug') || getQueryValue('vconsole')
  return debugValue === '1' || debugValue === 'true' || hasDebugStorage()
}

function normalizeValue (value) {
  if (value instanceof Error) {
    return {
      name: value.name,
      message: value.message,
      stack: value.stack
    }
  }
  return value
}

export function logWorldCupDebug (label, payload) {
  if (!shouldEnableWorldCupDebug()) return
  if (payload === undefined) {
    console.log(`[WC2026] ${label}`)
    return
  }
  console.log(`[WC2026] ${label}`, normalizeValue(payload))
}

export function removeWorldCupDebugUi () {
  const selectors = [
    '#__vconsole',
    '#wc2026-pre-debug-box',
    '#wc2026-pre-debug-toggle',
    '#wc2026-pre-debug-copybox'
  ]
  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(node => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node)
      }
    })
  })
}

export function installWorldCupDebug () {
  if (!shouldEnableWorldCupDebug() || window.__WC2026_APP_DEBUG_INSTALLED__) return
  window.__WC2026_APP_DEBUG_INSTALLED__ = true

  logWorldCupDebug('app debug installed', {
    href: window.location.href,
    userAgent: window.navigator.userAgent,
    readyState: document.readyState,
    viewport: {
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight,
      devicePixelRatio: window.devicePixelRatio
    }
  })

  window.addEventListener('error', event => {
    const target = event.target || event.srcElement
    if (target && target !== window && target.tagName) {
      logWorldCupDebug('resource error', {
        tagName: target.tagName,
        src: target.currentSrc || target.src || target.href || '',
        outerHTML: target.outerHTML
      })
      return
    }

    logWorldCupDebug('window error', {
      message: event.message,
      source: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      error: normalizeValue(event.error)
    })
  }, true)

  window.addEventListener('unhandledrejection', event => {
    logWorldCupDebug('unhandled rejection', normalizeValue(event.reason))
  })
}
